var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47368 12.3274V14.2716C10.4264 13.974 11.446 13.8827 12.4469 14.0054C13.4479 14.1281 14.4008 14.4613 15.2259 14.9769C16.0509 15.4926 16.7238 16.1756 17.1882 16.9688C17.6527 17.7619 17.8949 18.6419 17.8947 19.5349H20C20.0005 18.3989 19.7067 17.2779 19.1411 16.2577C18.5755 15.2376 17.7531 14.3454 16.737 13.6496C15.7209 12.9538 14.538 12.4728 13.279 12.2434C12.02 12.0141 10.7183 12.0434 9.47368 12.3274ZM11.5789 11.1628C15.0684 11.1628 17.8947 8.66512 17.8947 5.5814C17.8947 2.49767 15.0684 0 11.5789 0C8.08947 0 5.26316 2.49767 5.26316 5.5814C5.26316 8.66512 8.08947 11.1628 11.5789 11.1628ZM11.5789 9.30233C9.25263 9.30233 7.36842 7.63721 7.36842 5.5814C7.36842 3.52558 9.25263 1.86047 11.5789 1.86047C13.9053 1.86047 15.7895 3.52558 15.7895 5.5814C15.7895 7.63721 13.9053 9.30233 11.5789 9.30233ZM3.15789 14.8837H0V16.7442H3.15789V20L8.42105 15.814L3.15789 11.6279V14.8837Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/Requests.9aa252b2e0944c96a81602fa893d66c9.svg";
export { ForwardRef as ReactComponent };